import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DaysView from './DaysView';
import MonthsView from './MonthsView';
import YearsView from './YearsView';
import TimeView from './TimeView';

export default class CalendarContainer extends Component {
  static propTypes = {
    view: PropTypes.string,
    viewProps: PropTypes.object,
  };

  constructor (props) {
    super(props);

    this.viewComponents = {
      days: DaysView,
      months: MonthsView,
      years: YearsView,
      time: TimeView,
    };
  }

  render () {
    return React.createElement(this.viewComponents[ this.props.view ], this.props.viewProps);
  }
}



// WEBPACK FOOTER //
// ./src/containers/date-time-picker/CalendarContainer.js